'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import z from 'zod';
import { Admonition, admonitionSchema } from './admonition';

export const Important = (props: z.input<typeof admonitionSchema>) => {
  const t = useTranslations();
  const { children } = props;

  return (
    <Admonition severity="warning" title={t('mdx:alert:important')}>
      {children}
    </Admonition>
  );
};
